import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { LoginComponent } from '../login/login.component';
import { DataService } from '../../service/data/data.service';
import { UserDetails } from '../../model/userdetails';
import { ModuloService } from 'src/app/service/modulo/modulo.service';
import { Module } from 'src/app/model/module';
import { PerfilService } from 'src/app/service/perfil/perfil.service';
import { Perfil } from 'src/app/model/perfil';


@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit, AfterViewInit {
  exibeModuloCupom: boolean;
  exibeModuloUpload: boolean;
  exibeModuloRelatorio: boolean;
  exibeModuloRedeCredenciada: boolean = true;
  logo: string;

  constructor(private dataService: DataService,
    private moduloService: ModuloService,
    private perfilService: PerfilService) {
  }
  ngAfterViewInit() {


  }
  ngOnInit() {
    let user: UserDetails = JSON.parse(localStorage.getItem('idUser'));
    this.dataService.changeUserDetails(user);
    this.perfilService.GetPerfil(user.is_Rus).subscribe((result: Perfil) => {
      user.tp_Nivel_Master = result.tp_Nivel_Master;
      this.dataService.changeUserDetails(user); 
    });



    this.logo = user.ds_Logo;

    this.moduloService.Get(user.is_Rus).subscribe((modulos: Array<Module>) => {
      if (modulos)
        this.dataService.changeModules(modulos.map(value => { return value.is_Rmd }));

      this.dataService.currentModules.subscribe(modulos => {

        if (modulos) {
          //this.exibeModuloCupom = modulos.find((value) => value == 1) != null;
          this.exibeModuloUpload = modulos.find((value) => value == 2) != null;
          this.exibeModuloRelatorio = modulos.find((value) => value == 3) != null;
        }
      });
    });




  }



}
